
import { map, filter } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import { PAGE_CHANGED } from 'actions/globalActions'
import { isFeedPostsPage } from 'helpers/feedHelpers'
import { activateAnchorActionCreator } from 'actions/navigationActions'
import { byType } from 'rxOperators/byType'
import GlobalAction, { GetFeatureFlagsAction } from 'actions/globalActions'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { EpicRefined } from 'interfaces/middleware'
import { gqlFeatureFlagsQuery } from 'queries/featureFlagsQuery'

const pageChangedEpic: Epic = (action$, store) =>
  action$
    .pipe(byType(PAGE_CHANGED)).pipe(
      filter(isFeedPostsPage),
      filter((a) => a.payload.action === 'push'),
      filter(() => {
        const state = store.getState()
        // prevent anchor override
        return !state.app.navigation.activeAnchor
      }),
      map(() => {
        return activateAnchorActionCreator('feedtop', {
          block: 'start',
        })
      }))


const featureFlagsEpic: EpicRefined<GlobalAction> = (action$) => action$.pipe(
  filterRequest(GetFeatureFlagsAction.type),
  mergeMapAsync(async (action) => {
    try {
      const result = await gqlFeatureFlagsQuery()
      if (!result.error) {
        return action.success([...result.data.global.feature_flags])
      }

      return action.fail({ errorCode: 400 })
    } catch (e) {
      return action.fail({ errorCode: 400 })
    }
  }),
)


export default combineEpics(
  pageChangedEpic,
  featureFlagsEpic,
)
